import styled from 'styled-components';

export const StyledDd= styled.dd`
    
`